import { createEffect, createSignal, onCleanup, Show } from "solid-js";

interface AudioPlayerProps {
  uploadedFile?: File;
  blobUrl?: string;
  title?: string;
}

export default function AudioPlayer(props: AudioPlayerProps) {
  let audioRef: HTMLAudioElement | undefined;
  const [isPlaying, setIsPlaying] = createSignal(false);
  const [currentTime, setCurrentTime] = createSignal(0);
  const [duration, setDuration] = createSignal(0);
  const [fileUrl, setFileUrl] = createSignal<string | null>(null);

  const togglePlay = () => {
    if (!audioRef) return;
    if (isPlaying()) {
      audioRef.pause();
    } else {
      audioRef.play();
    }
  };

  const handleTimeUpdate = () => {
    if (audioRef) {
      setCurrentTime(audioRef.currentTime);
    }
  };

  const handleLoadedMetadata = () => {
    if (audioRef) {
      setDuration(audioRef.duration);
    }
  };

  const handleSeek = (e: Event) => {
    const target = e.target as HTMLInputElement;
    const time = parseFloat(target.value);
    if (audioRef) {
      audioRef.currentTime = time;
      setCurrentTime(time);
    }
  };

  const formatTime = (time: number) => {
    const mins = Math.floor(time / 60);
    const secs = Math.floor(time % 60);
    return `${mins}:${secs.toString().padStart(2, "0")}`;
  };

  createEffect(() => {
    // Prefer blobUrl (for saved sessions) over uploadedFile (for new uploads)
    if (props.blobUrl) {
      setFileUrl(props.blobUrl);
    } else if (props.uploadedFile) {
      setFileUrl(URL.createObjectURL(props.uploadedFile as any));
    }
  });
  
  onCleanup(() => {
    // Only revoke object URLs we created, not blob URLs from server
    if (fileUrl() && !props.blobUrl && props.uploadedFile) {
      URL.revokeObjectURL(fileUrl()!);
    }
  });
  return (
    <div class=" rounded-lg flex flex-col  w-full max-w-md shadow-sm">
      <Show when={props.title}>
        <div class="text-xs font-semibold text-gray-500 uppercase tracking-wider px-1 ">
          {props.title}
        </div>
      </Show>
      <div class="flex flex-row gap-2">
      <audio
        ref={audioRef}
        src={fileUrl()!}
        onTimeUpdate={handleTimeUpdate}
        onLoadedMetadata={handleLoadedMetadata}
        onPlay={() => setIsPlaying(true)}
        onPause={() => setIsPlaying(false)}
        onEnded={() => setIsPlaying(false)}
        class="hidden"
      />



        <div class="flex-1 flex flex-col ">
          <div class="flex items-center gap-3">
          <button
          onClick={togglePlay}
          class="w-5 h5 flex items-center justify-center rounded-full text-white  "
          aria-label={isPlaying() ? "Pause" : "Play"}
        >
          <Show when={isPlaying()} fallback={<span  >▶</span>}>
            <span>⏸</span>
          </Show>
        </button>
          <input
            type="range"
            min="0"
            max={duration() || 0}
            step="0.1"
            value={currentTime()}
            onInput={handleSeek}
            class="w-full h-1.5 bg-gray-200 appearance-none cursor-pointer "
          />
          </div>
       
          <div class="flex justify-between text-[10px] text-gray-500 font-mono">
            <span>{formatTime(currentTime())}</span>
            <span>{formatTime(duration())}</span>
          </div>
        </div>
      </div>
    </div>
  );
}
